

export default {
  state: {
    division: '',
    commission: ''
  },
  getters: {
    getSignUpDivision: (state) => state.division,
    getSignUpCommission: (state) => state.commission
  },
  mutations: {
    setSignUpDivision(state, value) {
      state.division = value
    },
    setSignUpCommission(state, value) {
      state.commission = value
    }
  }
}
